import FigmaDashboardIcon from './FigmaDashboardIcon';

interface Properties {
  width?: number;
  height?: number;
}

const DashboardIconActive = ({ width = 16, height = 16 }: Properties) => {
  return <FigmaDashboardIcon width={width} height={height} color='#FFFFFF' />;
};

export default DashboardIconActive;
